import { QueryBuilderSharp as ReserveIcon } from '@mui/icons-material';
import React from 'react';
import { commonStyles, css, StyleSheet } from '../../Common/styling';
import { Fab } from '@mui/material';

const styles = StyleSheet.create({
  reserveIcon: {
    position: 'relative',
    bottom: '1px',
    paddingRight: '10px',
    verticalAlign: 'middle',
  },
});

type Props = {
  onClick: any;
  text: string;
};

const ReserveFab: React.FC<Props> = (props) => {
  return (
    <Fab
      variant="extended"
      color="inherit"
      aria-label="Reserve"
      className={css(commonStyles.selectionFabStyle2)}
      onClick={props.onClick}
    >
      <ReserveIcon className={css(styles.reserveIcon)} />
      {props.text}
    </Fab>
  );
};

export default ReserveFab;
